﻿export const AppContainerId = 'veilederUtveksling';
export const BoksA = 'boksA';
export const BoksB = 'boksB'; 
export const BoksC = 'boksC'; 
export const BoksD = 'boksD'; 